export default "__VITE_ASSET__GuFi3bhg__"